export class Screenshot {
    public File: any;
    public FileName: string;
}
